// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__lR2aW","tab":"style_tab__89+Hw","active":"style_active__eKGsJ"};